export default __webpack_public_path__ + "static/media/05-01.90528abb.png";